import { Flex, Text } from '@gazin/ecommerce-ui'
import { formatarPreco } from 'src/util/formatar'
import { displayPromotionalTag } from 'src/util/promotionalEvent'

type DiscountTagProps = {
  discountValue: number
}

export default function PromotionTag({ discountValue }: DiscountTagProps) {
  return (
    <>
      {displayPromotionalTag(discountValue) && (
        <Flex
          bgColor="#0D71F0"
          borderRadius="0.125rem"
          justifyContent="center"
          lineHeight="1rem"
          maxW="12rem"
          px="0.625rem"
          py="0.25rem"
        >
          <Text color="#FFF" fontSize="0.813rem" mb="0">
            Economia de {formatarPreco(discountValue)}
          </Text>
        </Flex>
      )}
    </>
  )
}
